import * as React from 'react';
export const pauseFilledSvg = React.forwardRef(function pauseFilledSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2 0a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0V1a1 1 0 0 1 1-1Zm4 0a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0V1a1 1 0 0 1 1-1Z',
    }),
  );
});
pauseFilledSvg.defaultProps = {
  width: '8',
  height: '8',
  viewBox: '0 0 8 8',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var pauseFilled = {
  category: 'icon',
  colorable: true,
  name: 'pauseFilled',
  svg: pauseFilledSvg,
};
